/* ============================================
   BARA SKIN — Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // --- CART DRAWER TOGGLE ---
  const cartBtns = document.querySelectorAll('[data-cart-toggle]');
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    cartBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        cartDrawer.classList.toggle('is-open');
        document.body.classList.toggle('cart-open');
      });
    });
  }

  // --- ADD TO CART ---
  const addToCartForms = document.querySelectorAll('[data-add-to-cart-form]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart-btn]');
      const originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      const formData = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (res.ok) {
          btn.textContent = 'Added ✓';
          await updateCartCount();
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        }
      } catch (err) {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  });

  // --- CART COUNT UPDATE ---
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const badges = document.querySelectorAll('[data-cart-count]');
      badges.forEach(b => {
        b.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
      });
    } catch {}
  }
  updateCartCount();

  // --- MOBILE MENU ---
  const menuBtn = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
      document.body.classList.toggle('menu-open');
      menuBtn.setAttribute('aria-expanded', mobileMenu.classList.contains('is-open'));
    });
  }

  // --- SCROLL REVEAL ---
  const reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && reveals.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach(el => observer.observe(el));
  }

  // --- STICKY HEADER SHADOW ---
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

});
